import { ShiftPlanItem, ShiftPlanResponse } from '@/types/service-response'
import { ShiftFilterScope } from '@/types/enums'
import { ShiftListFilterValue } from '@/types/payload'

export class PlannedShift {
  private constructor (
    readonly projectId: number,
    readonly projectSerie: number,
    readonly projectShiftDetailId: number | null,
    readonly title: string,
    readonly isRepeating: boolean, // TODO: not good representation
    readonly isFixedShift: boolean,
    readonly isTemporaryShift: boolean,
    readonly start: Date,
    readonly end: Date,
    readonly shift: number,
    readonly addressId: number | null,
    readonly addressNumber: string,
    readonly addressName: string,
    readonly employee: string
  ) {}

  public get titleLowerCase (): string {
    return this.title.toLocaleLowerCase()
  }

  public satisfiesConditions(filter: ShiftListFilterValue, isAddressTable: boolean): boolean {
    const textList: string[] = filter.text.split(/[|,&]/)
    let conditions: Array<boolean> = []
    let textConditions: Array<boolean> = []

    if(isAddressTable) {
      textList.forEach((item: string) => {
        textConditions.push(this.employee.toLocaleLowerCase().includes(item.toLocaleLowerCase()) ||
          this.addressNumber.toLocaleLowerCase().includes(item.toLocaleLowerCase()) ||
          this.addressName.toLocaleLowerCase().includes(item.toLocaleLowerCase()))
      })
    } else {
      textConditions.push(this.title.toLocaleLowerCase().includes(filter.text.toLocaleLowerCase()))
    }

    if(textConditions.length > 0) {
      conditions.push(textConditions.some(v => v))
    } else {
      conditions.push(true)
    }

    if(filter.scope !== ShiftFilterScope.AllShifts) {
      if(filter.scope === ShiftFilterScope.FixedShifts) {
        conditions.push(this.isFixedShift)
      } else if (filter.scope === ShiftFilterScope.TemporaryShifts) {
        conditions.push(this.isTemporaryShift)
      }
    }

    return conditions.every(v => v)
  }

  public static createListFromResponse (data: ShiftPlanResponse): Array<PlannedShift> {
    const list: Array<PlannedShift> = data.map((item: ShiftPlanItem) => {
      return new PlannedShift(
        item.Projekte,
        item.ProjektSerie,
        item.ProjektSchichtDetail,
        item.Titel,
        !item.Einmalig,
        item.Fixiert,
        item.Provisorisch,
        item.Start,
        item.Ende,
        item.Schicht,
        item.AdressID,
        item.AdressNummer ? item.AdressNummer : '',
        item.AdressLinie,
        item.VollerName ? item.VollerName : ''
      )
    })

    return list
  }
}
